<template>
  <v-container class="pa-0 ma-0 industry-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>

    <div v-html="content.text1" class="industry-text"></div>
    <div>
      <v-btn
        rounded
        text
        href="https://questionarios.unl.pt/index.php?sid=25343&newtest=Y&lang=en"
        target="_blank"
        class="green white--text"
        >{{ content.text2 }}</v-btn
      >
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Mentor',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
